import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './../_services/services'
import { Global } from './../globals';
import { Helpers } from '../_models/helpers';
@Injectable({
  providedIn: 'root' 
})
export class AuthGuard  {

    constructor(private router: Router, private authenticationService: AuthenticationService, private globals: Global) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var loggedIn = this.authenticationService.isLoggedIn();
        if (loggedIn) {
            // logged in so return true
            this.globals.isAuthenticated = true;
           // Helpers.LogInfo("value is true","Auth");
           return this.globals.isAuthenticated;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}